<template>
 <div>
   <b-form-group
       label="Ürün İçerik"
       label-for="itemidlow"
   >
     <v-select
         id="itemidlow"
         v-model="itemData.itemidlow"
         :options="dataList"
         label="title"
         :reduce="item => item.id"
         placeholder="Seçiniz"
         @input="getDataList2"
     >
       <template v-slot:option="option">
         <div>
           {{ option.title }}
         </div>
         <div>
           <small class="text-warning">{{ option.main_categories }}</small>
         </div>
       </template>
     </v-select>
   </b-form-group>
   <b-form-group
       label="Ürün İçerik"
       label-for="itemid"
   >
     <v-select
         id="itemid"
         v-model="itemData.itemid"
         :options="dataListLow"
         label="title"
         :reduce="item => item.id"
         placeholder="Seçiniz"
         onselect="getDataList2(item.id)"
     >
       <template v-slot:option="option">
         <div>
           {{ option.title }}
         </div>
         <div>
           <small class="text-warning">{{ option.main_categories }}</small>
         </div>
       </template>
     </v-select>
   </b-form-group>
 </div>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'Products',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    dataList() {
      return this.$store.getters['productGroups/dataList']
    },
    dataListLow() {
      return this.$store.getters['products/dataListLow']
    },
    itemData() {
      return this.$store.getters['menus/dataItem']
    },
  },
  created() {
    this.getDataList()
    this.getDataList2()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('productGroups/getDataList', {
        where: {
          'product_categories.id_product_categories ': null,
        },
      })
    },
    getDataList2(id) {
      this.$store.dispatch('products/getDataList2', {
        where: { 'products.id_product_categories ': id },
      })
    },
  },
}
</script>
